/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { find } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { requestPlansIfNotRequested } from 'state/kiosk-plans/actions';
import { getAllKioskPlans, requestingKioskPlans } from 'state/kiosk-plans/selectors';
import { swapSubscription } from 'state/subscriptions/actions';
import { getCurrentKioskId, getCurrentKioskPlanId, getCurrentKiosk} from 'state/current-kiosk/selectors';
import { successNotice } from 'state/notices/actions';
import { requestAddonsIfNotRequested } from 'state/addons/actions';
import Loader from './loader';
import { getAllAddons } from 'state/addons/selectors';
import Plan from './plan';
import Preloader from 'components/preloader';
import cscom from 'lib/customer-site-api';
import cb from 'lib/chargebee';
import Money from 'components/money';
import ConfirmNewPlanAlert from './confirm-new-plan-alert'; // Import
import { requestCurrentKiosk } from 'state/current-kiosk/actions';
import { getCurrentUser } from 'state/current-user/selectors';
import { requestCouponsIfNotRequested } from 'state/coupons/actions';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import FlashMessage from 'components/flash-message';
import page from 'page';

/**
 * Style dependencies
 */
import './styles.scss';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const SelectKioskPlan = (props) => {
    const kioskPlans = props.kioskPlans;
    const [submitting, setSubmitting] = useState(false);

    const onChange = (value) => {
        if (!props.kioskSubscriptionId) {
            return newPlanSubscription(value);
        }

        let plan = find(kioskPlans, { id: value });
        let addon = resolveLicenseAddon(plan);
    };

    useEffect(() => {
        props.requestKioskPlans();
        props.requestAddons();
        props.requestCoupons();
    }, []);

    const handleSubmit = (value) => {
        setSubmitting(true);
        return props
            .swapSubscription(props.kioskSubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your Customer Self Checkout subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(() => setSubmitting(false));
    };

    const newPlanSubscription = (planId) => {
        cb.openCheckout({
            hostedPage: () => cscom.hostedPage().newPlanSubscription(planId),
            error: (e) => console.log(e),
            close: () => { /*parent.location.reload();*/ },
            success: () => {
                props.requestCurrentKiosk();
                props.successNotice('Your Customer Self Checkout subscription has been created.');
                page.redirect('/dashboard/kiosk');
            },
        });
    };

    const resolveLicenseAddon = (plan) => {
        return null;
    };

    if (props.requesting) {
        return <Loader />;
    }

    return (
        <form onSubmit={handleSubmit}>
            <Box>
                <Stack space='xxlarge'>
                    {kioskPlans.map((plan, i) => {
                        return (
                            <Plan
                                key={plan.id}
                                plan={plan}
                                onClick={() => onChange(plan.id)}
                                disabled={
                                    !(props.currentKiosk && props.currentKiosk.status == 'cancelled')
                                        ? plan.id == props.kioskPlanId
                                        : null
                                }
                                licenseAddon={resolveLicenseAddon(plan)}
                                numberLicenses={props.currentUser.additionalLicenses}
                            />
                        );
                    })}
                </Stack>
            </Box>
        </form>
    );
};

export default connect(
    (state) => ({
        kioskPlans: getAllKioskPlans(state),
        addons: getAllAddons(state),
        kioskSubscriptionId: getCurrentKioskId(state),
        kioskPlanId: getCurrentKioskPlanId(state),
        currentKiosk: getCurrentKiosk(state),
        currentUser: getCurrentUser(state),
        requesting: requestingKioskPlans(state),
    }),
    {
        requestKioskPlans: requestPlansIfNotRequested,
        requestCurrentKiosk,
        requestCoupons: requestCouponsIfNotRequested,
        swapSubscription,
        successNotice,
        requestAddons: requestAddonsIfNotRequested,
    },
)(SelectKioskPlan);
